import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { combineReducers } from "redux";

// Slices
import sessionSlice from "./actions/sessionSlice";
import firstLaunchSlice from "./actions/firstLaunchSlice";
import variablesSlice from "./actions/variblesSlice";
import deliveryMethodSlice from "./actions/deliveryMethodSlice";
import cartSlice from "./actions/cartSlice";

const rootReducer = combineReducers({
  session: sessionSlice,
  firstLaunch: firstLaunchSlice,
  variables: variablesSlice,
  delivery: deliveryMethodSlice,
  cart: cartSlice,
});

const persistConfig = {
  key: "root",
  storage: AsyncStorage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
